import { render, staticRenderFns } from "./IntroductionPage.vue?vue&type=template&id=8036287c&scoped=true"
import script from "./IntroductionPage.vue?vue&type=script&lang=js"
export * from "./IntroductionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036287c",
  null
  
)

export default component.exports